var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", [
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drugsFilter,
                    expression: "drugsFilter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "radio", id: "r1", value: "all" },
                domProps: { checked: _vm._q(_vm.drugsFilter, "all") },
                on: {
                  change: function ($event) {
                    _vm.drugsFilter = "all"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "custom-control-label", attrs: { for: "r1" } },
                [_vm._v("Все препараты")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drugsFilter,
                    expression: "drugsFilter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "radio", id: "r2", value: "noCodes" },
                domProps: { checked: _vm._q(_vm.drugsFilter, "noCodes") },
                on: {
                  change: function ($event) {
                    _vm.drugsFilter = "noCodes"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "custom-control-label", attrs: { for: "r2" } },
                [_vm._v("Без штрих кода")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drugsFilter,
                    expression: "drugsFilter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "radio", id: "r3", value: "noUteka" },
                domProps: { checked: _vm._q(_vm.drugsFilter, "noUteka") },
                on: {
                  change: function ($event) {
                    _vm.drugsFilter = "noUteka"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "custom-control-label", attrs: { for: "r3" } },
                [_vm._v("Без uteka")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center mt-3",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records && _vm.records.length
            ? [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-1" },
                  [
                    _c("thead", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tr",
                        _vm._l(_vm.suppliersData, function (s) {
                          return _c("th", [_vm._v(_vm._s(s))])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.filteredRecords, function (r, i) {
                          return [
                            _c(
                              "tr",
                              [
                                _c("td", { attrs: { rowspan: "2" } }, [
                                  _vm._v(_vm._s(i + 1)),
                                ]),
                                _vm._v(" "),
                                _c("td", { attrs: { rowspan: "2" } }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        (r.site_details[0] &&
                                          r.site_details[0].text_value) ||
                                          "нет названия на проекте ЛШ"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(r.title))]),
                                ]),
                                _vm._v(" "),
                                _vm._l(r.barcodes, function (d) {
                                  return [
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: d.text_value,
                                            expression: "d.text_value",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: { value: d.text_value },
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateRecord(r.id)
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              d,
                                              "text_value",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "tr",
                              [
                                _vm._l(_vm.suppliersData, function (s) {
                                  return [
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              r.suppliersData[s].text_value,
                                            expression:
                                              "r.suppliersData[s].text_value",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { placeholder: s, type: "text" },
                                        domProps: {
                                          value: r.suppliersData[s].text_value,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateRecord(r.id)
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              r.suppliersData[s],
                                              "text_value",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { rowspan: "2" } }),
      _vm._v(" "),
      _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", [_vm._v("BARCODE")]),
      _vm._v(" "),
      _c("th", [_vm._v("BARCODE")]),
      _vm._v(" "),
      _c("th", [_vm._v("BARCODE")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }